import Empty from './index.vue';

export default Empty;
